module.exports = __webpack_public_path__ + "img/w71.55deaf4b.svg";